module.exports = __webpack_public_path__ + "static/media/we-can-min.de9f05f3.png";